var render = function render(){var _vm=this,_c=_vm._self._c;return _c('geko-base-crud',{attrs:{"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }